import { Calls } from '@components/Calls/Calls'
import { useAppDispatch } from '@hooks/redux'
import { RoutePaths } from '@interfaces/routePaths'
import {
  clearBreadcrumbs,
  setActionsButton,
  setActiveSection,
  setInviteButton,
} from '@redux/site/siteSlice'
import { useEffect } from 'react'

export const Base = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setActiveSection('Calls'))
    dispatch(clearBreadcrumbs())
    dispatch(setInviteButton(false))
    dispatch(setActionsButton(false))
  })

  return (
    <Calls
      fullWidth
      state={{
        history: [
          {
            title: 'Calls',
            href: RoutePaths.CALLS,
          },
        ],
      }}
    />
  )
}
